function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M157.149 74.482a89.532 89.532 0 01-5.128 29.034 131.007 131.007 0 00-24.955 42.247v.189-.189a131.416 131.416 0 00-24.765-42.087 89.729 89.729 0 01-5.143-29.136 89.184 89.184 0 014.764-27.941 130.43 130.43 0 0125.202-43.602 130.155 130.155 0 0125.261 43.427 88.508 88.508 0 014.764 28.058v0z",
  stroke: "#1A1A1A",
  strokeWidth: 3,
  strokeMiterlimit: 10
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M102.125 103.675A89.882 89.882 0 0079.079 84.97a86.049 86.049 0 00-20.555-8.041c-7.095-28.874.116-56.51.116-56.51a130.124 130.124 0 0143.107 26.121 89.176 89.176 0 00-4.764 27.941 89.745 89.745 0 005.142 29.194v0z",
  stroke: "#1A1A1A",
  strokeWidth: 3,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M127.007 145.967c-.655.189-42.902 10.634-77.079-8.377C15.404 118.477 2 76.58 2 76.58s27.68-7.022 56.523.335A86.052 86.052 0 0179.08 84.97a89.877 89.877 0 0123.046 18.705 132.674 132.674 0 0124.882 42.291zM195.478 76.914a86.288 86.288 0 00-20.556 8.056 89.987 89.987 0 00-22.901 18.56 89.532 89.532 0 005.128-29.034 88.535 88.535 0 00-4.763-28.058 130.194 130.194 0 0142.975-26.018s7.211 27.606.117 56.494z",
  stroke: "#1A1A1A",
  strokeWidth: 3,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M252 76.58s-13.403 41.839-47.929 61.011c-34.249 18.938-76.394 8.566-77.064 8.391L127 146c5.583-15.528 14.057-30.069 24.962-42.455a89.988 89.988 0 0122.959-18.574 86.277 86.277 0 0120.555-8.041c28.83-7.372 56.524-.35 56.524-.35z",
  stroke: "#1A1A1A",
  strokeWidth: 3,
  strokeMiterlimit: 10
});

function SvgLotusinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 254 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgLotusinline;